<template>
  <v-row>
    <v-col cols="12" md="12" PANNELS>
      <v-card class="elevation-0">
        <paging
          :resourceSettings="resourceSettings"
          :resource="updates"
          @loadResource="loadResource"
          @pageByNumber="pageByNumber"
        />
        <v-card-text>
          <v-row>
            <v-col md="3" cols="12" FILTERS>
              <v-select 
                v-model="pending"
                small 
                outlined 
                dense 
                autocomplete="disabled"
                hide-details
                label="Pending only"
                :items="[{text: 'All', value: null}, {text: 'No', value: false}, {text: 'Yes', value: true}]"
                @change="filterLeads()"
                ></v-select>
            </v-col>
            <v-col sm="1" cols="12" class="ml-auto">
              <v-btn block @click.stop="$emit('openDialog', 'update')" color="primary">
                {{ i18n.new }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="updates.data && updates.data.length > 0">
            <v-col cols="12" class="mb-2 py-0">
              <v-timeline dense clipped>
                <v-timeline-item
                  v-for="(timeline, key) in updates.data"
                  :key="`call-${key}`"
                  :color="timeline.pending ? 'grey' : timeline.approved ? 'success' : 'red'"
                  icon-color="grey lighten-2"
                  small
                >
                  <v-row justify="space-between" class="align-center elevation-2">
                    <v-col cols="12" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n.employee_name }}
                      </div>
                      <v-chip small dark color="info" label :class="`${arabic ? 'arFont' : 'enFont'}`">
                        {{ timeline.employee_name.name }}
                      </v-chip>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["updated_field"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ i18n[timeline.update_field] }}</div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["updated_value"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.update_value }}</div>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["updated_status"] }}
                      </div>
                      <v-chip small v-if="timeline.pending" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                        i18n["pending"]
                      }}</v-chip>
                      <v-chip small color="success" v-if="timeline.approved" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                        i18n["approved"]
                      }}</v-chip>
                      <v-chip small color="error" v-if="timeline.rejected" :class="`${arabic ? 'arFont' : 'enFont'}`">{{
                        i18n["rejected"]
                      }}</v-chip>
                    </v-col>
                    <v-col cols="6" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["last_update"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ getFormat(timeline.updated_at) }}</div>
                    </v-col>
                    <v-col cols="12" v-if="timeline.note" class="py-1">
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                        {{ i18n["note"] }}
                      </div>
                      <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ timeline.note }}</div>
                    </v-col>
                    <v-col>
                      <v-row>
                        <v-col class="pb-0 pt-0">
                          <div>
                            <v-btn small @click.prevent="$emit('editResource', 'update', timeline)" class="mr-2" color="primary">Edit</v-btn>
                            <v-btn small @click.prevent="$emit('deleteResource', 'update', timeline)" color="error">Delete</v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Paging from "@/components/Paging";
import { format } from "timeago.js";

export default {
  components: { Paging },
  props: ["updates"],
  data() {
    return {
      pending: null,
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
    };
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    buildFilter() {
      let filter = ``

      if(this.pending != null) {
        filter += `?filter[pending]=${this.pending}`
      }

      return filter;
    },
    filterLeads() {
      this.loadResource()
    },
    getFormat(d) {
      return format(d);
    },
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    firstLettersName(name) {
      const split_names = name.split(" ");

      if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase();

      return (split_names[0][0] + split_names[0][1]).toUpperCase();
    },
    loadResource() {
      console.log(this.buildFilter());
      this.$emit("loadResource", "interviews", "interviews", this.buildFilter());
    },
    pageByNumber(page) {
      this.$emit("pageByNumber", "interviews", "interviews", page);
    },
  },
};
</script>
